import withPage from '@lib/page';
import ContactPage from '@views/pages/contact';

export default withPage(ContactPage);
